import { Button, Col, Divider, Dropdown, Menu, Row, Modal, Select, Pagination } from 'antd';
import { CaretDownOutlined, PhoneFilled, ArrowRightOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie';
import api from '../utils/apiRoutes';
import GlobalLoading from '../Containers/GlobalLoading';
// import { saveAs } from 'file-saver';
// import JSZip from 'jszip';
// import axios from 'axios';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import axios from 'axios';
import { get_v10_url } from '../utils/commonUtilities';

const { Option } = Select

// const getDate = (date) => {
//   if (date) {
//     if (date[date.length - 1] !== 'Z') return date;

//     const isoDate = new Date(date);
//     const day = isoDate.getUTCDate();
//     const month = isoDate.getUTCMonth() + 1;
//     const year = isoDate.getUTCFullYear();

//     const formattedDay = day < 10 ? `0${day}` : day;
//     const formattedMonth = month < 10 ? `0${month}` : month;

//     const formattedDateString = `${formattedDay}-${formattedMonth}-${year}`;
//     return formattedDateString;
//   }
//   return date;

// }

const admittedIcon = (
<svg width="41" height="44" viewBox="0 0 41 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M37.1716 37.0353V43.2656H40.8632V23.508C40.8635 23.2661 40.8161 23.0266 40.7237 22.803C40.6312 22.5795 40.4956 22.3763 40.3246 22.2052C40.1536 22.034 39.9505 21.8982 39.727 21.8055C39.5034 21.7129 39.2638 21.6651 39.0218 21.665C38.5319 21.6643 38.0618 21.8581 37.7149 22.2037C37.3679 22.5493 37.1725 23.0184 37.1716 23.508V32.5758H4.02588V19.7806C4.02588 18.7633 3.13823 17.9357 2.11757 17.9357V17.937C1.10025 17.937 0.298828 18.7633 0.298828 19.78V43.2649H4.02521V37.0346L37.1716 37.0353ZM25.4738 0.938168C26.6549 0.938168 28.5892 1.43448 29.6654 2.61147L28.2149 5.39562C27.8917 4.97649 27.4764 4.6372 27.0011 4.40393C26.5259 4.17067 26.0033 4.04968 25.4738 4.0503C24.3716 4.0503 23.391 4.56465 22.7567 5.36823L21.2775 2.67292C22.5228 1.4278 24.2446 0.9375 25.4738 0.9375V0.938168ZM25.056 3.7437H25.8835V2.91607H26.7117V2.09044H25.8835V1.26348H25.056V2.09044H24.2292V2.91607H25.056V3.7437Z" fill="#92A6CC"/>
<path d="M6.70802 24.7867C6.70785 24.4335 6.77913 24.0838 6.9178 23.7575C7.05646 23.4312 7.25978 23.1348 7.51611 22.8852C7.77244 22.6356 8.07676 22.4377 8.41163 22.3029C8.7465 22.1681 9.10536 22.099 9.46765 22.0996C9.82999 22.0991 10.1889 22.1682 10.5238 22.3031C10.8587 22.4379 11.163 22.6357 11.4195 22.8853C11.6759 23.1348 11.8793 23.4312 12.0182 23.7575C12.157 24.0838 12.2285 24.4335 12.2286 24.7867C12.2286 25.5004 11.9378 26.1849 11.4201 26.6895C10.9025 27.1942 10.2004 27.4777 9.4683 27.4777C8.73623 27.4777 8.03414 27.1942 7.51649 26.6895C6.99883 26.1849 6.70802 25.5004 6.70802 24.7867ZM33.3632 23.1408C34.5771 23.1408 35.5573 24.0685 35.5677 25.2429L35.5722 30.918H13.4216V23.1465L33.3632 23.1408ZM10.8709 30.9135C11.62 30.9135 12.2286 30.3203 12.2286 29.5899C12.2286 28.8596 11.62 28.2664 10.8709 28.2664H6.94623C6.76797 28.2663 6.59145 28.3005 6.42676 28.367C6.26207 28.4335 6.11246 28.531 5.98647 28.6539C5.86048 28.7769 5.7606 28.9228 5.69255 29.0834C5.62449 29.244 5.58959 29.4162 5.58985 29.5899C5.58985 30.3203 6.19384 30.9135 6.94623 30.9135H10.8709Z" fill="#92A6CC"/>
<path d="M28.4449 7.46885C28.4449 8.15535 28.1641 8.81372 27.6642 9.29915C27.1642 9.78457 26.4862 10.0573 25.7792 10.0573C25.0722 10.0573 24.3942 9.78457 23.8942 9.29915C23.3943 8.81372 23.1135 8.15535 23.1135 7.46885C23.1135 6.78236 23.3943 6.12398 23.8942 5.63856C24.3942 5.15313 25.0722 4.88043 25.7792 4.88043C26.4862 4.88043 27.1642 5.15313 27.6642 5.63856C28.1641 6.12398 28.4449 6.78236 28.4449 7.46885ZM23.2159 10.7947C21.3524 10.8044 20.2727 12.2726 20.0297 13.102L17.7592 20.3379H20.0571L21.7305 14.786H22.9213L21.2526 20.3366H30.2937L28.6371 14.786H29.8272L31.5448 20.3379H33.8086L31.5294 13.102C31.2871 12.283 30.2301 10.8427 28.4075 10.7985L23.2159 10.7947ZM6.2294 12.4585C2.95755 12.4585 0.298828 9.87562 0.298828 6.69866C0.298828 3.52105 2.95688 0.9375 6.2294 0.9375C9.49992 0.9375 12.1626 3.5217 12.1626 6.69866C12.1626 9.87562 9.49925 12.4585 6.2294 12.4585ZM6.22739 11.0325C8.68931 11.0325 10.6934 9.08853 10.6934 6.69736C10.6934 4.30879 8.68998 2.36154 6.22739 2.36154C3.76681 2.36154 1.76608 4.30814 1.76608 6.69736C1.76608 9.08918 3.76681 11.0325 6.22739 11.0325Z" fill="#92A6CC"/>
<path d="M6.17727 7.942C6.11388 7.98088 6.04414 7.99762 5.9746 7.99064C5.90505 7.98365 5.83797 7.95318 5.77964 7.90207C5.73026 7.8596 5.68826 7.80346 5.65649 7.73745C5.62472 7.67144 5.6039 7.59709 5.59544 7.51942L5.58984 3.23454C5.594 3.09121 5.63951 2.9556 5.71684 2.85616C5.79416 2.75672 5.89729 2.70117 6.00459 2.70117C6.11188 2.70117 6.21501 2.75672 6.29234 2.85616C6.36966 2.9556 6.41518 3.09121 6.41933 3.23454V6.55863L8.54501 5.22017C8.6434 5.16603 8.7536 5.16456 8.85279 5.21605C8.95197 5.26755 9.03254 5.36807 9.07781 5.49679C9.12308 5.62551 9.12957 5.77258 9.09595 5.90753C9.06233 6.04249 8.99118 6.15498 8.89721 6.22172L6.17727 7.942Z" fill="#92A6CC"/>
</svg>
)

const dischargedIcon = (
<svg width="41" height="33" viewBox="0 0 33 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.93165 1.1227C9.65289 0.820791 9.32191 0.581261 8.95762 0.417783C8.59332 0.254306 8.20284 0.170082 7.80847 0.169922C7.4141 0.169762 7.02356 0.253669 6.65915 0.41685C6.29474 0.580032 5.9636 0.819294 5.68464 1.12097L5.124 1.72772C4.58189 1.56066 4.00829 1.55419 3.46308 1.70898C2.91787 1.86376 2.42107 2.17413 2.02455 2.60767C1.4291 3.25864 1.09508 4.13761 1.09508 5.0536C1.09508 5.96958 1.4291 6.84856 2.02455 7.49953L2.68792 8.22262V17.4074H0.298828V19.1311H1.93137C1.53588 19.5504 1.26476 20.0878 1.15259 20.6746C1.04042 21.2614 1.09228 21.871 1.30156 22.4258C1.51083 22.9806 1.86804 23.4553 2.32764 23.7895C2.78723 24.1237 3.32838 24.3022 3.88207 24.3022C4.43576 24.3022 4.97691 24.1237 5.4365 23.7895C5.89609 23.4553 6.2533 22.9806 6.46258 22.4258C6.67185 21.871 6.72371 21.2614 6.61154 20.6746C6.49937 20.0878 6.22825 19.5504 5.83276 19.1311H26.6194C26.224 19.5504 25.9528 20.0878 25.8407 20.6746C25.7285 21.2614 25.7804 21.871 25.9896 22.4258C26.1989 22.9806 26.5561 23.4553 27.0157 23.7895C27.4753 24.1237 28.0164 24.3022 28.5701 24.3022C29.1238 24.3022 29.665 24.1237 30.1246 23.7895C30.5842 23.4553 30.9414 22.9806 31.1507 22.4258C31.3599 21.871 31.4118 21.2614 31.2996 20.6746C31.1874 20.0878 30.9163 19.5504 30.5208 19.1311H32.1534V17.4074H28.9679V14.7244C29.6518 14.5392 30.2586 14.1114 30.6916 13.5094C31.1246 12.9074 31.3589 12.1658 31.357 11.4029C31.357 9.5154 29.9546 7.98389 28.2241 7.98389H11.5355C11.5033 7.98398 11.4714 7.97718 11.4416 7.96387C11.4118 7.95056 11.3847 7.931 11.3619 7.90632L11.0704 7.58744L11.3643 7.27114C11.6433 6.96946 11.8647 6.61124 12.0157 6.21695C12.1668 5.82266 12.2445 5.40003 12.2446 4.97319C12.2447 4.54636 12.1671 4.12369 12.0161 3.72934C11.8652 3.33499 11.644 2.97668 11.3651 2.67489L9.93165 1.1227ZM9.94757 6.36533L10.2382 6.05162C10.3692 5.90995 10.4731 5.74174 10.544 5.5566C10.6149 5.37145 10.6514 5.173 10.6514 4.97258C10.6514 4.77217 10.6149 4.57372 10.544 4.38857C10.4731 4.20343 10.3692 4.03521 10.2382 3.89355L8.80479 2.34222C8.54053 2.0559 8.18201 1.89487 7.80807 1.89455C7.43413 1.89422 7.07538 2.05463 6.81069 2.34049L6.53197 2.64214L9.94757 6.36533ZM27.3752 17.4074H4.28065V9.95753L8.48147 14.5348C8.6503 14.7184 8.87806 14.8218 9.11617 14.8218H27.3752V17.4074Z" fill="#30BB4D"/>
</svg>
)

const underProcessIcon = (
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginLeft:'5px', marginRight:'5px'}}>
<path d="M15.0519 29.1013H15.0514C13.0818 29.1013 11.238 28.7277 9.51447 27.9835C7.7802 27.2347 6.27709 26.222 5.00016 24.946C3.72342 23.6702 2.71089 22.1674 1.9631 20.4323C1.21975 18.7076 0.846169 16.8636 0.84522 14.8948C0.844271 12.9264 1.21778 11.0828 1.9629 9.35835C2.71275 7.62295 3.72547 6.11983 5.00044 4.84391C6.27522 3.56819 7.77811 2.55561 9.51427 1.80679C11.2399 1.0625 13.0838 0.688968 15.0514 0.688968C17.0189 0.688968 18.8628 1.0625 20.5884 1.80679C22.3246 2.55561 23.8275 3.56819 25.1023 4.84391C26.3773 6.11988 27.3905 7.62308 28.1414 9.35858C28.8874 11.0828 29.2603 12.9262 29.2575 14.8943C29.2546 16.8634 28.881 18.7078 28.1394 20.4328C27.3937 22.1675 26.3813 23.6701 25.1028 24.9457C23.8237 26.2221 22.3203 27.2354 20.5878 27.9852C18.8667 28.7301 17.0233 29.1032 15.0519 29.1013ZM7.67683 17.6544C8.43384 17.654 9.09524 17.3828 9.6292 16.8501C10.1643 16.3162 10.4356 15.6534 10.4344 14.8942C10.4332 14.1364 10.1624 13.4748 9.62964 12.942C9.09688 12.4093 8.43507 12.1383 7.67684 12.1358C6.91579 12.1334 6.25225 12.4057 5.71982 12.9442C5.19092 13.4792 4.91947 14.1387 4.91583 14.8925C4.91217 15.6505 5.18549 16.3131 5.72202 16.8497C6.25815 17.3858 6.91999 17.6588 7.67683 17.6544ZM15.0531 17.6544C15.8101 17.654 16.4715 17.3828 17.0055 16.8501C17.5405 16.3162 17.8118 15.6534 17.8106 14.8942C17.8094 14.1364 17.5387 13.4748 17.0059 12.942C16.4731 12.4093 15.8113 12.1383 15.0531 12.1358C14.2921 12.1334 13.6285 12.4057 13.0961 12.9442C12.5672 13.4792 12.2957 14.1387 12.2921 14.8925C12.2884 15.6505 12.5618 16.3131 13.0983 16.8497C13.6344 17.3858 14.2963 17.6588 15.0531 17.6544ZM22.4294 17.6544C23.1864 17.654 23.8478 17.3828 24.3817 16.8501C24.9168 16.3162 25.1881 15.6534 25.1869 14.8942C25.1857 14.1364 24.915 13.4748 24.3822 12.942C23.8494 12.4093 23.1876 12.1383 22.4294 12.1358C21.6683 12.1334 21.0048 12.4057 20.4723 12.9442C19.9434 13.4792 19.672 14.1387 19.6684 14.8925C19.6647 15.6505 19.938 16.3131 20.4745 16.8497C21.0107 17.3858 21.6725 17.6588 22.4294 17.6544Z" fill="#92A6CC" stroke="#92A6CC" stroke-width="1.09278"/>
</svg>
)

function PatientDetails(props) {

  // const [filters, setFilters] = useState({ date: '', location: '', limit: 10 });
  // const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [showInsuranceModal, setShowInsuranceModal] = useState(false);
  // const [insuranceModalData, setInsuranceModalData] = useState({});

  // const [showUserModal, setShowUserModal] = useState(false);
  // const [userModalData, setUserModalData] = useState({});

  const [admittedData, setAdmittedData] = useState([])
  const [total, setTotal] = useState(0)
  const [dischargedData, setDischargedData] = useState([])
  const [underProcessData, setUnderProcessData] = useState([])
  const [selectedOption, setSelectedOption] = useState('Admitted')
  const [selectedDate, setSelectedDate] = useState('')
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [uniqueID, setUniqueID] = useState('')
  const [docDetails, setDocDetails] = useState([])
  const [insDetails, setInsDetails] = useState(null)
  const [name, setName] = useState('')
  const [docDetailsModal, setDocDetailsModal] = useState(false)
  const [insDetailsModal, setInsDetailsModal] = useState(false)

  // const onClickDate = (e) => {
  //   // console.log(e.key, 'here');
  //   setFilters({ ...filters, date: e.key });
  // };
  // const onClickLocation = (e) => {
  //   // console.log(e.key, 'here');
  //   setFilters({ ...filters, location: e.key });
  // };

  // useEffect(() => {
  //   const headers = { 'Authorization':`Bearer ${Cookies.get('token_medical_auth')}` }
  //   setLoading(true);

  //   api.patientsDetails.getPatientDetails({}, headers, filters).then(res => {
  //     setData((res.data?.[0]?.data || []));
  //     console.log(res, "HERE");
  //     setLoading(false);
  //   }).catch(err => {
  //     console.log(err);
  //     setLoading(false);
  //   })

  // }, [filters])

  const AdmittedRenderData = ({data}) => {
    return (
      <>
        <div className='individual-data-container'>
          <Link to={`/dashboard/booking/booking-details?id=${data._id}`}>
          <div className='heading admitted-head'>
            <div className='left-head'>
              {/* <h4>IP: {data.ipNumber ? data.ipNumber : '-'}</h4> */}
              <h4>{data.userName}</h4>
              <h4>{data.patientAge}yrs</h4>
            </div>
            <h4><PhoneFilled/> {data.userMobileNumber}</h4>
          </div>
          </Link>
          <div className='data-body'>
            <Link to={`/dashboard/booking/booking-details?id=${data._id}`}>
            <Row gutter={24} style={{marginBottom:'0.75rem'}}>
              <Col span={7}><p>Insurance Provider-</p></Col>
              <Col span={17}><p>{data.insuranceDetails?.insurancePartner ? data.insuranceDetails?.insurancePartner : 'N/A'}</p></Col>
            </Row>
            <Row gutter={24} style={{marginBottom:'0.75rem'}}>
              <Col span={7}><p>Hospital-</p></Col>
              <Col span={17}><p>{data.professionalName}</p></Col>
            </Row>
            <Row gutter={24}>
              <Col span={7}><p>Treatment-</p></Col>
              <Col span={17}><p>{data.treatment ? data.treatment : 'Not Updated Yet'}</p></Col>
            </Row>
            </Link>
            <div className='additional-details'>
              <Link to={`/dashboard/booking/booking-details?id=${data._id}`}>
              <div className='date'>
                {admittedIcon}
                <div>
                  <p>Admitted</p>
                  <p>{data.doa}</p>
                </div>
              </div>
              </Link>
              <Link to={`/dashboard/booking/booking-details?id=${data._id}`}>
              <div className='bill-amount'>
                <p>Bill Amount</p>
                <p style={{color:'#2257BA'}}>{ data?.paymentDetails?.finalBill ? (isNaN(data?.paymentDetails?.finalBill) ? '-' : `₹ ${Number(data?.paymentDetails?.finalBill).toLocaleString('en-IN')}`) : '-'}</p>
              </div>
              </Link>
              <div className='documents'>
                <p style={{backgroundColor:'#C5D9FF', cursor:'pointer'}} onClick={()=>{setUniqueID(data._id); setName(data.userName); setDocDetails(data.timeLine); setDocDetailsModal(true)}}>Documents <ArrowRightOutlined style={{color:'#7B9FE3'}}/></p>
                <p style={{backgroundColor:'#B8FA6A', cursor:'pointer'}} onClick={()=>{setUniqueID(data._id); setName(data.userName); setInsDetails(data.insuranceDetails); setInsDetailsModal(true)}}>Insurance Details <ArrowRightOutlined style={{color:'#7B9FE3'}}/></p>
                {/* <p style={{backgroundColor:'#67F9F4', cursor:'pointer'}}>View All <ArrowRightOutlined style={{color:'#7B9FE3'}}/></p> */}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  const DischargedRenderData = ({data}) => {
    return (
      <>
      {/* {console.warn("data: ", data)} */}
        <div className='individual-data-container'>
          <Link to={`/dashboard/booking/booking-details?id=${data._id}`}>
          <div className='heading discharged-head'>
            <div className='left-head'>
              {/* <h4>IP: {data.ipNumber ? data.ipNumber : '-'}</h4> */}
              <h4>{data.userName}</h4>
              <h4>{data.patientAge}yrs</h4>
            </div>
            <h4><PhoneFilled/> {data.userMobileNumber}</h4>
          </div>
          </Link>
          <div className='data-body'>
            <Link to={`/dashboard/booking/booking-details?id=${data._id}`}>
            <Row gutter={24} style={{marginBottom:'0.75rem'}}>
              <Col span={7}><p>Insurance Provider-</p></Col>
              <Col span={17}><p>{data.insuranceDetails?.insurancePartner ? data.insuranceDetails?.insurancePartner : 'N/A'}</p></Col>
            </Row>
            <Row gutter={24} style={{marginBottom:'0.75rem'}}>
              <Col span={7}><p>Hospital-</p></Col>
              <Col span={17}><p>{data.professionalName}</p></Col>
            </Row>
            <Row gutter={24}>
              <Col span={7}><p>Treatment-</p></Col>
              <Col span={17}><p>{data.treatment ? data.treatment : 'Not Updated Yet'}</p></Col>
            </Row>
            </Link>
            <div className='additional-details top-margin'>
              <Link to={`/dashboard/booking/booking-details?id=${data._id}`}>
              <div className='date-container'>
                <div className='date'>
                  {admittedIcon}
                  <div>
                    <p>Admitted</p>
                    <p>{data.doa}</p>
                  </div>
                </div>
                <div className='date'>
                  {dischargedIcon}
                  <div>
                    <p>Discharged</p>
                    <p>{data.dod}</p>
                  </div>
                </div>
              </div>
              </Link>
              <Link to={`/dashboard/booking/booking-details?id=${data._id}`}>
              <div className='bill-amount'>
                <p>Bill Amount</p>
                <p style={{color:'#2257BA'}}>{ data?.paymentDetails?.finalBill ? (isNaN(data?.paymentDetails?.finalBill) ? '-' : `₹ ${Number(data?.paymentDetails?.finalBill).toLocaleString('en-IN')}`) : '-'}</p>
              </div>
              </Link>
              <div className='documents'>
                <p style={{backgroundColor:'#C5D9FF', cursor:'pointer'}} onClick={()=>{setUniqueID(data._id); setName(data.userName); setDocDetails(data.timeLine); setDocDetailsModal(true)}}>Documents <ArrowRightOutlined style={{color:'#7B9FE3'}}/></p>
                <p style={{backgroundColor:'#B8FA6A', cursor:'pointer'}} onClick={()=>{setUniqueID(data._id); setName(data.userName); setInsDetails(data.insuranceDetails); setInsDetailsModal(true)}}>Insurance Details <ArrowRightOutlined style={{color:'#7B9FE3'}}/></p>
                {/* <p style={{backgroundColor:'#67F9F4', cursor:'pointer'}}>View All <ArrowRightOutlined style={{color:'#7B9FE3'}}/></p> */}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  const UnderProcessRenderData = ({data}) => {
    return (
      <>
        <div className='individual-data-container'>
          <Link to={`/dashboard/booking/booking-details?id=${data._id}`}>
          <div className='heading under-process-head'>
            <div className='left-head'>
              {/* <h4>IP: {data.ipNumber ? data.ipNumber : '-'}</h4> */}
              <h4>{data.userName}</h4>
              <h4>{data.patientAge}yrs</h4>
            </div>
            <h4><PhoneFilled style={{color:'#FFFFFF'}}/> {data.userMobileNumber}</h4>
          </div>
          </Link>
          <div className='data-body'>
            <Link to={`/dashboard/booking/booking-details?id=${data._id}`}>
            <Row gutter={24} style={{marginBottom:'0.75rem'}}>
              <Col span={7}><p>Service Provider-</p></Col>
              <Col span={17}><p>{data.insuranceDetails?.insurancePartner ? data.insuranceDetails?.insurancePartner : 'N/A'}</p></Col>
            </Row>
            <Row gutter={24} style={{marginBottom:'0.75rem'}}>
              <Col span={7}><p>Hospital-</p></Col>
              <Col span={17}><p>{data.professionalName}</p></Col>
            </Row>
            <Row gutter={24}>
              <Col span={7}><p>Treatment-</p></Col>
              <Col span={17}><p>{data.treatment ? data.treatment : 'Not Updated Yet'}</p></Col>
            </Row>
            </Link>
            <div className='additional-details top-margin'>
              <Link to={`/dashboard/booking/booking-details?id=${data._id}`}>
              <div className='date-container'>
                <div className='date'>
                  {admittedIcon}
                  <div>
                    <p>Admitted</p>
                    <p>{data.doa}</p>
                  </div>
                </div>
                <div className='date'>
                  {underProcessIcon}
                  <div>
                    <p>Under Process</p>
                  </div>
                </div>
              </div>
              </Link>
              <Link to={`/dashboard/booking/booking-details?id=${data._id}`}>
              <div className='bill-amount'>
                <p>Bill Amount</p>
                <p style={{color:'#2257BA'}}>{ data?.paymentDetails?.finalBill ? (isNaN(data?.paymentDetails?.finalBill) ? '-' : `₹ ${Number(data?.paymentDetails?.finalBill).toLocaleString('en-IN')}`) : '-'}</p>
              </div>
              </Link>
              <div className='documents'>
                <p style={{backgroundColor:'#C5D9FF', cursor:'pointer'}} onClick={()=>{setUniqueID(data._id); setName(data.userName); setDocDetails(data.timeLine); setDocDetailsModal(true)}}>Documents <ArrowRightOutlined style={{color:'#7B9FE3'}}/></p>
                <p style={{backgroundColor:'#B8FA6A', cursor:'pointer'}} onClick={()=>{setUniqueID(data._id); setName(data.userName); setInsDetails(data.insuranceDetails); setInsDetailsModal(true)}}>Insurance Details <ArrowRightOutlined style={{color:'#7B9FE3'}}/></p>
                {/* <p style={{backgroundColor:'#67F9F4', cursor:'pointer'}}>View All <ArrowRightOutlined style={{color:'#7B9FE3'}}/></p> */}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  const renderData = () => {
    let dataToRender = [];
    switch (selectedOption) {
      case 'Admitted':
        dataToRender = admittedData;
        break;
      case 'Discharged':
        dataToRender = dischargedData;
        break;
      case 'Pending':
        dataToRender = underProcessData;
        break;
      default:
        break;
    }
    return dataToRender.map((item, index) => (
      <>
      {selectedOption==='Admitted' ? <AdmittedRenderData data={item}/> : <></>}
      {selectedOption==='Discharged' ? <DischargedRenderData data={item}/> : <></>}
      {selectedOption==='Pending' ? <UnderProcessRenderData data={item}/> : <></>}
      </>
    ));
  };

  useEffect(()=> {
    const headers  = { 
      Authorization: `Bearer ${Cookies.get("token_medical_auth")}`
    }
    axios.get(`${get_v10_url()}/professional/getDashboardBookings?page=${currentPage}&limit=10&patientStatus=${selectedOption}&date=${selectedDate}`, {headers})
    .then(res => {
      // console.warn('Patient Data Here: ', res.data.data[0].data)
      if(selectedOption==='Admitted') {
        setAdmittedData(res.data.data[0].data)
      }
      if(selectedOption==='Discharged') {
        setDischargedData(res.data.data[0].data)
      }
      if(selectedOption==='Pending') {
        setUnderProcessData(res.data.data[0].data)
      }
      setTotal(res.data?.data[0].count[0]?.total)
    })
  },[selectedOption, selectedDate, currentPage, pageSize])

  if (loading) return <GlobalLoading />
  
return (
  <>
  <div className='dash-patient-details-container'>
    <div className='top-bar'>
      <h3>Patient Profile List</h3>
      <div style={{display:'flex', alignItems:'center', gap:'2rem'}}>
        <Select value={selectedOption} onChange={e => {
          setSelectedOption(e)
          setCurrentPage(1)
          setSelectedDate('')
        }} className='data-selector' suffixIcon={<CaretDownOutlined style={{color:'#111111'}}/>}
          style={{border:`1px solid ${selectedOption==='underProcess' ? '#C5D9FF' :'#1EB6B9'}`, color:`${selectedOption==='underProcess' ? '#C5D9FF' : selectedOption==='admitted' ? '#92A6CC': '#30C118'}`}}
          getPopupContainer={trigger => trigger.parentElement}
        >
          <Option value='Admitted'>Admitted</Option>
          <Option value='Discharged'>Discharged</Option>
          <Option value='Pending'>Under Process</Option>
        </Select>
        <Select value={selectedDate ? selectedDate : 'Date'} onChange={e => setSelectedDate(e)} className='date-selector' suffixIcon={<CaretDownOutlined style={{color:'#3788E5'}}/>} getPopupContainer={trigger => trigger.parentElement}>
          <Option value='Today'>Today</Option>
          <Option value='This%20month'>This month</Option>
          <Option value='This%20week'>This week</Option>
          <Option value=''>All Dates</Option>
        </Select>
      </div>
    </div>
    <Divider style={{borderBottom:'1px solid #CDCDCD', margin:'1rem 0 0 0'}}/>
    <div className='patient-profile-list-container' style={{ height: `calc(${props.maxHeight}px - 134px)`, overflowY: 'scroll' }}>
      {renderData()}
    </div>
    <Pagination
      current={currentPage}
      pageSize={pageSize}
      total={total}
      onChange={(page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
      }}
    />
  </div>
  <Modal
    key={uniqueID}
    width={'50%'}
    visible={insDetailsModal}
    title={`Insurance Details of ${name}`}
    onCancel={()=>setInsDetailsModal(false)}
    onOk={()=>setInsDetailsModal(false)}
    className='insurance-details-modal'
  >
    <div className='insurance-details-body-container'>
      <Row gutter={24}>
        <Col span={10}>
          <label>Policy Number</label>
          <p>{insDetails?.policyNumber ? insDetails?.policyNumber : 'N/A'}</p>
        </Col>
        <Col span={14}>
          <label>Insurance Provider</label>
          <p>{insDetails?.insurancePartner ? insDetails?.insurancePartner : 'N/A'}</p>
        </Col>
      </Row>
    </div>
  </Modal>
  <Modal
    key={uniqueID}
    width={'50%'}
    visible={docDetailsModal}
    title={`All Documents of ${name}`}
    onCancel={()=>setDocDetailsModal(false)}
    onOk={()=>setDocDetailsModal(false)}
    className='insurance-details-modal'
  >
    <div className='insurance-details-body-container'>
      {docDetails && docDetails.length > 0 && docDetails.some(items => items.docURL) ?
      (<>
      <Row gutter={24} style={{marginBottom:'0.75rem'}}>
        <Col span={18}><p style={{color:'#00A82E', margin:'0'}}>Document Type</p></Col>
        <Col span={6} type='flex' align='middle'><p style={{color:'#00A82E', margin:'0'}}>Download URL</p></Col>
      </Row>
      {docDetails?.map((item,idx) => (
        <div key={idx} className='documents-container'>
          {item.docURL && <Row gutter={24}>
            <Col span={18}><p>{item.desc}</p></Col>
            <Col span={6} type='flex' align='middle'><a href={item.docURL} target='_blank'>Download</a></Col>
          </Row>}
          {idx!==(docDetails.length-1) &&<Divider style={{borderBottom:'1px solid #DAE3F8', margin:'0.5rem 0'}}/>}
        </div>
      ))}
      </>) :
      <>
      <h4>Currently there are no documents uploaded for {name}</h4>
      </>
      }
    </div>
  </Modal>
  </>
)
}

export default PatientDetails